import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function AsistanCard({
  isTeacherTurn,
  speakText,
  isSpeaking,
  TextValue,
  activeLevel,
}) {
  const [changeContent, setChangeContent] = useState("");
  const contentValue = useSelector((state) => state.contents.contentValues);

  const changeValue = (contentValue, activeLevel) => {
    let currentContent = "";
    if (contentValue.section === "reading" && activeLevel === "verbs") {
      currentContent = contentValue?.verbs?.[TextValue];
    }
    if (contentValue.section === "reading" && activeLevel === "Story") {
      currentContent = contentValue?.Articles?.Story;
    }
    if (contentValue.section === "vocabulary") {
      currentContent = contentValue?.contents?.[TextValue];
    }
    if (contentValue.section === "grammar" && activeLevel === "examples") {
      currentContent = contentValue?.examples?.[TextValue];
    }
    if (contentValue.section === "grammar" && activeLevel === "exercises") {
      currentContent = contentValue?.exercises?.[TextValue];
    }
    return currentContent;
  };
  useEffect(() => {
    const returnvalue = changeValue(contentValue, activeLevel);
    if (returnvalue) {
      setChangeContent(returnvalue);
    } else {
      console.log("İçerik bulunamadı:", {
        section: contentValue?.section,
        activeLevel,
        TextValue,
      });
      setChangeContent(""); // İçerik bulunamazsa state'i temizle
    }
  }, [activeLevel, contentValue, TextValue]); // Tüm bağımlılıkları ekle
  return (
    <div
      className={`${
        isTeacherTurn ? "bg-yellow-500" : "bg-gray-200"
      } rounded-2xl p-4 md:p-6 shadow-xl border-l-4 ${
        isTeacherTurn ? "border-purple-500" : "border-gray-400"
      } hover:shadow-2xl transition-all h-auto`}
    >
      <div
        className="flex flex-col sm:flex-row items-start
             sm:items-center justify-between gap-3 mb-4"
      >
        <div className=" hidden sm:flex  items-center gap-2">
          <span className="text-xl md:text-3xl">🤖</span>
          <div className="flex flex-col ">
            <p
              className={`text-lg md:text-xl font-bold ${
                isTeacherTurn ? "text-gray-800" : "text-gray-500 "
              }`}
            >
              Your Assistant
            </p>
            <hr className="border-b-2 border-purple-500" />
            <p>Senin Asistanın</p>
          </div>
        </div>

        <button
          onClick={() => speakText(changeContent.Eng || changeContent)}
          disabled={!isTeacherTurn || isSpeaking}
          className={`px-6 py-3 font-semibold rounded-lg shadow-md 
                  transition-all flex items-center gap-2 text-sm md:text-base 
                  w-full sm:w-auto justify-center ${
                    isTeacherTurn && !isSpeaking
                      ? "bg-purple-500 hover:bg-purple-600 text-white"
                      : "bg-gray-400 text-gray-100 cursor-not-allowed"
                  }`}
        >
          <span className="text-3xl">🔊</span>
          <div className="flex flex-col">
            <p> {isSpeaking ? "Listening..." : "Listen"}</p>
            <hr className="border-b-2 border-yellow-500" />
            <p> {isSpeaking ? "Dinleniliyor..." : "Dinlemi"}</p>
          </div>
        </button>
      </div>
    </div>
  );
}

export default AsistanCard;
